export const walletConnectProjectId = "800f916e0fe9421fb73c01c96cdda221";
